/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { type ISocialVideoFormat, socialVideoFormatSchema } from '../social-video-format-schema';

export const backfillSocialVideosV1ResultSchema = z.object({
  queued: z.number(),
  format: socialVideoFormatSchema,
});

export interface IBackfillSocialVideosV1Result {
  queued: number;
  format: ISocialVideoFormat;
}

export const backfillSocialVideosV1ResponseSchema = createApiResponseSchema(
  backfillSocialVideosV1ResultSchema,
) as z.ZodSchema<IAPI<IBackfillSocialVideosV1Result>>;

export type IBackfillSocialVideosV1Response = IAPI<IBackfillSocialVideosV1Result>;
